/* EpgContext */
import Addon from '@shared/classes/addon';
import Category from '@shared/classes/category';
import Event from '@shared/classes/event';
import Rail from '@shared/classes/rail';
import Setting from '@shared/classes/setting';
import { createContext } from 'react';
import { EpgConfig, EpgLayout } from '@shared/types/interfaces/epg';

/**
 * Props for the EpgContext.
 */
interface EpgContextProps {
  asset?: Addon | Event | Setting;
  category?: Category;
  channels?: Rail;
  config: EpgConfig;
  date?: Date;
  layout: EpgLayout;
  rails?: Rail[];
  selection?: string;
  changeAsset: (id: string, index: number) => void;
  hoverAsset: (asset: Addon | Event | Setting) => void;
  selectAsset: (id: string, index: number) => void;
}

const EpgContext = createContext<EpgContextProps>({
  asset: undefined,
  category: undefined,
  config: {
    collapse: false,
    display: {
      description: false,
      filter: false,
    },
  },
  date: undefined,
  layout: {},
  rails: undefined,
  selection: undefined,
  changeAsset: () => null,
  hoverAsset: () => null,
  selectAsset: () => null,
});

export default EpgContext;
export type { EpgContextProps };
